import SideBarButton from "./SideBarButton";
import { navigateTo } from "context/navigation.service";
import { useDataStore } from "@store/user_org";
import { isGUEST } from "@helpers/accessHelpers";
import { isOwnerOrAdmin, useSimulateMemberView } from "@utils/permissions";

export default function SettingBar({
  page,
  setPage,
}: {
  page: string;
  setPage: (page: string) => void;
}) {
  const userData = useDataStore((state) => state.userData);
  const isGuest = isGUEST(userData);
  const isAdmin = userData?.config?.admin === true;
  useSimulateMemberView();
  const isManager = isOwnerOrAdmin(userData);

  return (
    <div className="w-64 min-w-64 h-screen justify-start pt-10 pl-2 border-r-1 flex flex-col">
      <div className="flex flex-col pl-2">
        <div className="ml-3 font-semibold text-hx">Paramètres</div>
        <div className="flex flex-col mt-6 mr-6">
          <SideBarButton
            label="Compte"
            name="user"
            highlighted={page === "account"}
            onClick={() => navigateTo({ route: "/settings?page=account" })}
          />
          {!isGuest && (
            <>
              {isManager && (
                <SideBarButton
                  label="Entreprise"
                  name="business"
                  highlighted={page === "company"}
                  onClick={() => navigateTo({ route: "/settings?page=company" })}
                />
              )}
              <SideBarButton
                label="Equipe"
                name="users"
                highlighted={page === "team"}
                onClick={() => navigateTo({ route: "/settings?page=team" })}
              />
              {isManager && (
                <SideBarButton
                  label="Dispo atelier"
                  name="sett-dispo"
                  highlighted={page === "dispo-atelier" || page === "disponibilites" || page === "service-rapide"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=dispo-atelier" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Réceptions"
                  name="side-reception"
                  highlighted={page === "receptions"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=receptions" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Prise de RDV"
                  name="sett-rdv"
                  highlighted={page === "prise-rdv"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=prise-rdv" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Interventions"
                  name="sett-interventions"
                  highlighted={page === "interventions"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=interventions" })
                  }
                />
              )}
              <SideBarButton
                label="Tags"
                name="tag"
                highlighted={page === "tags"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=tags" })
                }
              />
              <SideBarButton
                label="Avis clients"
                name="star"
                highlighted={page === "avis"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=avis" })
                }
              />
              {isManager && (
                <SideBarButton
                  label="Signatures"
                  name="sett-sign"
                  highlighted={page === "signatures"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=signatures" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Rappels devis"
                  name="cloche"
                  highlighted={page === "devis-reminders"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=devis-reminders" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Rappels RDV"
                  name="cloche"
                  highlighted={page === "rdv-reminders"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=rdv-reminders" })
                  }
                />
              )}
              {isManager && (
                <SideBarButton
                  label="Paiements"
                  name="sett-payments"
                  highlighted={page === "paiements"}
                  onClick={() =>
                    navigateTo({ route: "/settings?page=paiements" })
                  }
                />
              )}
<SideBarButton
                label="Notifications"
                name="cloche"
                highlighted={page === "notifications"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=notifications" })
                }
              />
              {isManager && (
                <>
                  <SideBarButton
                    label="ServiceBox"
                    name="sett-servicebox"
                    highlighted={page === "servicebox"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=servicebox" })
                    }
                  />
                  <SideBarButton
                    label="Sync ServiceBox"
                    name="sett-servicebox"
                    highlighted={page === "servicebox-sync"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=servicebox-sync" })
                    }
                  />
                  <SideBarButton
                    label="Pré-transfert SB"
                    name="sett-servicebox"
                    highlighted={page === "servicebox-batch-transfer"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=servicebox-batch-transfer" })
                    }
                  />
                  <SideBarButton
                    label="Véhicules clients"
                    name="car"
                    highlighted={page === "client-vehicles"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=client-vehicles" })
                    }
                  />
                  <SideBarButton
                    label="Téléphonie 3CX"
                    name="phone"
                    highlighted={page === "threecx"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=threecx" })
                    }
                  />
                  <SideBarButton
                    label="Facturation"
                    name="facturation"
                    highlighted={page === "facturation" || page === "messagerie"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=facturation" })
                    }
                  />
                  <SideBarButton
                    label="Stockage"
                    name="storage"
                    highlighted={page === "stockage"}
                    onClick={() =>
                      navigateTo({ route: "/settings?page=stockage" })
                    }
                  />
                </>
              )}
              {/* <SideBarButton
                label="Modèles emails"
                name="email"
                highlighted={page === "email-templates"}
                onClick={() =>
                  navigateTo({ route: "/settings?page=email-templates" })
                }
              /> */}
              {isAdmin && (
                <>
                  <SideBarButton
                    label="Utilisateurs"
                    name="users"
                    highlighted={page === "users"}
                    onClick={() => navigateTo({ route: "/settings?page=users" })}
                  />
                  <SideBarButton
                    label="Proxys"
                    name="sett-servicebox"
                    highlighted={page === "proxy-dashboard"}
                    onClick={() => navigateTo({ route: "/settings?page=proxy-dashboard" })}
                  />
                  <SideBarButton
                    label="Communications"
                    name="email"
                    highlighted={page === "communications"}
                    onClick={() => navigateTo({ route: "/settings?page=communications" })}
                  />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
